const createHistory = require('history').createBrowserHistory;

// eslint-disable-next-line import/prefer-default-export
export const history = createHistory({
  basename: '/',
});
